import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { useTranslation } from '@crehana/i18n';
import { nextSeoDefaultProps } from "../seo";
import { jsx as _jsx } from "react/jsx-runtime";
function generateAlternates(domain, path) {
  var countryCodes = ['es-pe', 'es-ar', 'es-mx', 'es-co', 'es-es', 'es-cl', 'es-bo', 'es-cr', 'es-ec', 'pt-br'];
  var pathWithoutCountry = path;
  if (pathWithoutCountry !== '/') {
    var countryCodeRegex = /^\/(?:pe|ar|mx|co|es|cl|bo|cr|ec|br)\//;
    var matchesCountryCode = path.match(countryCodeRegex);
    if (matchesCountryCode !== null) {
      pathWithoutCountry = path.replace(countryCodeRegex, '');
    }
  } else {
    // If the path is a single slash, just ignore it
    pathWithoutCountry = '';
  }
  var countryAlternates = countryCodes.map(function (code) {
    var country = code.split('-')[1];
    return {
      href: "".concat(domain, "/").concat(country, "/").concat(pathWithoutCountry),
      hrefLang: code
    };
  });
  countryAlternates.push({
    href: "".concat(domain, "/").concat(pathWithoutCountry),
    hrefLang: 'x-default'
  });
  return countryAlternates;
}
/**
 * This component attempts tu facilitate and reduce boilerplate code needed to
 * add SEO to any Crehana page.
 *
 * The only required prop is `hasCountryCode` which is needed to add language
 * alternates if the URL contains a `countryCode`, E.g.: `/es/cursos-online-marketing-digital/community-management-para-principiantes/`
 */
export var CrehanaNextSeo = function CrehanaNextSeo(props) {
  // asPath already contains countryCode
  var _useRouter = useRouter(),
    asPath = _useRouter.asPath;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var title = nextSeoDefaultProps.title,
    titleTemplate = nextSeoDefaultProps.titleTemplate,
    description = nextSeoDefaultProps.description,
    facebook = nextSeoDefaultProps.facebook,
    twitter = nextSeoDefaultProps.twitter,
    openGraph = nextSeoDefaultProps.openGraph,
    additionalMetaTags = nextSeoDefaultProps.additionalMetaTags;
  var metaTitle = props.title || title;
  var metaTitleTemplate = props.titleTemplate || titleTemplate;
  var metaDescription = props.description || description;
  var domain = process.env.API_URL;
  var path = props.path || asPath.split('?')[0];
  var fullUrl = domain + path;
  return /*#__PURE__*/_jsx(NextSeo, _objectSpread(_objectSpread({}, props), {}, {
    title: metaTitle,
    titleTemplate: metaTitleTemplate,
    description: metaDescription,
    canonical: fullUrl,
    facebook: facebook,
    twitter: _objectSpread(_objectSpread({}, twitter), props.twitter),
    openGraph: _objectSpread(_objectSpread({}, openGraph), {}, {
      title: metaTitleTemplate ? metaTitleTemplate.replace(/%s/, metaTitle) : metaTitle,
      description: metaDescription,
      url: fullUrl
    }, props.openGraph),
    additionalMetaTags: [{
      property: 'lang',
      content: languageCode
    }].concat(_toConsumableArray(additionalMetaTags || []), _toConsumableArray(props.additionalMetaTags || [])),
    languageAlternates: props.hasCountryCode ? generateAlternates(domain, path) : undefined
  }));
};
export default CrehanaNextSeo;